var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSigninPasswordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6004 9.5998C21.6007 10.7244 21.3376 11.8334 20.8321 12.8381C20.3267 13.8427 19.5929 14.7149 18.6896 15.3848C17.7864 16.0548 16.7387 16.5039 15.6306 16.696C14.5226 16.8882 13.3849 16.8181 12.3088 16.4914L12.0004 16.7998L10.8004 17.9998L9.60039 19.1998H7.20039V21.5998H2.40039V16.7998L7.50879 11.6914C7.20933 10.7014 7.12667 9.65853 7.26644 8.63373C7.40622 7.60894 7.76514 6.62628 8.31878 5.75265C8.87242 4.87902 9.60779 4.13493 10.4748 3.57102C11.3419 3.00711 12.3202 2.63662 13.3433 2.48476C14.3664 2.33291 15.4101 2.40326 16.4036 2.69102C17.397 2.97878 18.3168 3.4772 19.1004 4.15236C19.8839 4.82751 20.5128 5.66355 20.9442 6.60357C21.3756 7.54358 21.5994 8.56551 21.6004 9.5998ZM14.4004 4.7998C14.0821 4.7998 13.7769 4.92623 13.5519 5.15127C13.3268 5.37631 13.2004 5.68154 13.2004 5.9998C13.2004 6.31806 13.3268 6.62328 13.5519 6.84833C13.7769 7.07337 14.0821 7.1998 14.4004 7.1998C15.0369 7.1998 15.6474 7.45265 16.0974 7.90274C16.5475 8.35283 16.8004 8.96328 16.8004 9.5998C16.8004 9.91806 16.9268 10.2233 17.1519 10.4483C17.3769 10.6734 17.6821 10.7998 18.0004 10.7998C18.3187 10.7998 18.6239 10.6734 18.8489 10.4483C19.074 10.2233 19.2004 9.91806 19.2004 9.5998C19.2004 8.32676 18.6947 7.10586 17.7945 6.20569C16.8943 5.30551 15.6734 4.7998 14.4004 4.7998Z",
    fill: "#17BAB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigninPasswordIcon);
export default __webpack_public_path__ + "static/media/signin_password_icon.a57292f7c2874c94cc89870c508f52ab.svg";
export { ForwardRef as ReactComponent };